import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Box, Typography } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CommonButton from "../../../component/Button";
import { CustomDiv } from "../../chat-bot/style";
import { CommonGrid2 } from "../../common-components/StyledComponents";
import PopupTickIco from "../../../assets/icons/PopupTickIco";
import { HandleSkeletion } from "../../../utils/constants";
import TransationFailedIco from "../../../assets/icons/TransationFailedIco";
import { PlanBillingValidationCheck } from "../../../redux/action/OrganizationSetup";
import { platformBlackLogo } from "../../../utils/logo";

export default function TransactionStatus() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const query = new URLSearchParams(useLocation().search);
  const sessionId = query.get("session_id");

  const functionCall = async () => {
    try {
      setLoading(true);
      let payload = {
        session_id: sessionId,
      };
      await PlanBillingValidationCheck(payload);
      let existingCredential =
        JSON.parse(localStorage.getItem("credential")) || {};

      let updatedCredential = {
        ...existingCredential,
        active: true,
      };
      localStorage.setItem("credential", JSON.stringify(updatedCredential));
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (sessionId) {
      functionCall();
    }
  }, []);
  return (
    <CommonGrid2
      container
      alignItems={"baseline"}
      height={"100vh"}
      sx={{
        padding: {
          xs: "2rem 1rem",
          sm: "2rem 2rem",
          md: "2rem 4rem",
          lg: "2rem 6rem",
        },
      }}
      flexWrap={"wrap"}
    >
      <CustomDiv width="fit-content">
        {platformBlackLogo({height: "50px"})}
      </CustomDiv>
      <CommonGrid2 item size={12}>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          height="100%"
          width={{
            xs: "100%",
            sm: "100%",
            md: "50%",
            lg: "50%",
          }}
          margin={"auto"}
          alignItems={"center"}
          gap={"1rem"}
          borderRadius={"10px"}
          padding={"3rem 2rem"}
          sx={{
            boxShadow: "2px 2px 10px 5px #0000000D",
          }}
        >
          {loading ? (
            <HandleSkeletion height={50} width={"100%"} transform="scale(1)" />
          ) : (
            <Fragment>
              {sessionId === null ? <TransationFailedIco /> : <PopupTickIco />}
            </Fragment>
          )}

          {loading ? (
            <HandleSkeletion height={50} width={"80%"} transform="scale(1)" />
          ) : (
            <Typography variant="h1" fontWeight={600}>
              Payment {`${sessionId === null ? "Failed" : "Successful"}`} !
            </Typography>
          )}
          {loading ? (
            <HandleSkeletion height={50} width={"50%"} transform="scale(1)" />
          ) : (
            <CommonButton
              value="Continue"
              endIcon={<ArrowForwardIcon />}
              onClick={() => {
                setLoading(true);
                navigate("/auth/login");
              }}
              variant="contained"
              fontWeight={600}
              marginTop="1rem"
              padding={"10px 2rem"}
              gap={loading ? "10px" : "0px"}
              loading={loading}
              disabled={loading}
            />
          )}
        </Box>
      </CommonGrid2>
    </CommonGrid2>
  );
}
